import React from "react";
import { css } from "emotion";
import { defaultStyle } from "./styles";

export const ItemCardInfoMilesReductionTickets = ({}) => {
	return (
		<div
			className={css`
				${defaultStyle}
			`}
		>
			<p className="title">O que são passagens com redução de milhas?</p>
			<p>
				Cliente Smiles da categoria Diamante pode resgatar até 10 passagens por ano utilizando no
				máximo 35.000 milhas, mesmo que o voo tenha quantidade de milhas maior para emissão.
				<br />
				<br />
				Defina quantas passagens podemos emitir com este benefício de redução de milhas Diamante. Em
				cada uma delas, serão utilizadas 35.000 milhas. Quanto mais passagens você liberar, mais
				rápidas serão suas vendas.
			</p>
		</div>
	);
};
